import "../10. Battle/Library/LibraryBoxBattle.scss";
import Control from "../1. Core/Control";
import NP, {ValueChangedEventArgs} from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../1. Core/Delegate";
import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import StatesFilterPanel from "../10. Battle/Library/Panels/StatesFilterPanel";
import TabControl from "../1. Core/Controls/TabControl/TabControl";

import AthletesList from "./AthletesList";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import {getCharColor} from "../10. Battle/Util";
import {loadFile} from "../1. Core/ScriptLoader";
import {getSportType, PageMode, SportType} from "../10. Battle/types";
import RegionStatPanel from "./RegionStatPanel";

const loadedMaps = {} as any;

export interface IState {
	Name: string,
	Id: number,
	ISO: string,
	Raiting: number,
	SumRaiting: number,
	Efficiency: number
	TopoId: number
}

interface IStateListItem {
	State: IState
	Name: string,
	Rating: number,
	SumRating: number,
	Efficiency: number
	Image: string,
	ISO: string;
	Id: number;
}

export interface IStateFiltersSort {
	FilterText?: string,
	RegionId: number,
	RegionName: string,
	WeightCategory: number,
	Sex: number | string,
	SortField: string,
	SortDirection: number
	SportType?: SportType
}

export default class StatesList extends Control {
	private _Count: number;
	private _Offset: number;
	private _DrillDownMode: boolean;
	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;
	private _States: IStateListItem[];
	private _dataTable: DataTable;
	private _filtersPanel: StatesFilterPanel;
	private _drillDownPanel: AthletesList | RegionStatPanel;

	private _statesListNode: HTMLElement;
	private _dataWithFiltersNode: HTMLElement;
	private _tabs: TabControl;
	private _mapNode: HTMLElement;
	private mapChart: any;
	private _sizeTimeout: any;

	private _PageMode: PageMode


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._PageMode = PageMode.states;
		this._DrillDownMode = false;
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this._FilterText = '';
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._Count = 100;
		this._Offset = 0;

		this._statesListNode = NP.createNode(this._root);

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: 'States',
			ParentNode: this._statesListNode,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._refreshList(this._filtersPanel.getFilterData());
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._FilterText = null;
				this._refreshList(this._filtersPanel.getFilterData());
			},
			ShowSearchButton: true,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			EvFocusSearch: () =>
			{
			}
		});

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.tune,
			Value: 'Filters',
			EvClick: (btn: IconToggleButton) =>
			{
				btn.setData(!btn.getData())
				this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
				this.setWidth(this._Width);
			}
		}));

		this._tabs = new TabControl({
			ParentNode: this._statesListNode,
			Items: [{
				Content: NP.RM.getString('Table2'),
				Value: 'Table'
			}, {
				Content: NP.RM.getString('Map'),
				Value: 'Map'
			}],
			EvTabSelected: () =>
			{
				if (this._tabs.getValue() == "Table")
					this.showTable();
				else
					this.showMap();

				this._filtersPanel.setSortVisible(this._tabs.getValue() == "Table");
			}
		});

		this._dataWithFiltersNode = NP.createNode(this._statesListNode, 'data-with-filters-container');
		this._mapNode = NP.createNode(this._statesListNode, 'data-with-filters-container');

		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: false,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('State'),
				PropertyContent: 'Name',
				Width: '25%'
			}, {
				Content: NP.RM.getString('SumRating'),
				PropertyContent: 'SumRating',
				Width: '25%',
				Class: 'sum-rating-col'
			}, {
				Content: NP.RM.getString('Efficiency'),
				PropertyContent: 'Efficiency',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Rating'),
				PropertyContent: 'Rating',
				Width: '25%'
			}],
			ShowPaginator: false,
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						break;
					case 1:
						this._filtersPanel.setSortValues('SumRaiting', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
					case 2:
						this._filtersPanel.setSortValues('Efficiency', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
					case 3:
						this._filtersPanel.setSortValues('Rating', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
				}
			},
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvItemClick: (s: object, e: { Item: IStateListItem }) =>
			{
				if (this._PageMode == PageMode.mmastates)
					this.showRegionCard(e.Item.State)
				else
					this.showAthletesFilteredByState(e.Item.State);
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvItemContextMenu: () =>
			{
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
		});


		this._filtersPanel = new StatesFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			EvFilterSortChanged: (sender: StatesFilterPanel, args: IStateFiltersSort) =>
			{
				this._refreshList(args);
				this._updateDashFilters(args);
			}
		});
	}

	showTable()
	{
		this._dataTable.show();
		NP.showNode(this._dataWithFiltersNode)
		NP.hideNode(this._mapNode)
	}

	showMap()
	{
		NP.hideNode(this._dataWithFiltersNode)
		this._dataTable.hide();
		this.renderMap()
	}


	_updateDashFilters(args: IStateFiltersSort)
	{

	}

	showRegionCard(state: IState)
	{

		NP.hideNode(this._statesListNode);
		NP.hideNode(this._mapNode)

		this._drillDownPanel = new RegionStatPanel({
			ParentNode: this._root,
			State: state,
			Width: this._Width,
			Height: this._Height
		})

		this.bindDrill();

	}

	showAthletesFilteredByState(state: IState)
	{

		NP.hideNode(this._statesListNode);

		let filterData = this._filtersPanel.getFilterData();
		this._drillDownPanel = new AthletesList({
			ParentNode: this._root,
			Mode: this._PageMode,
			UseCity: true,
			DrillDownFilter: {
				StateId: state.Id,
				WeightCategory: filterData.WeightCategory,
				Sex: filterData.Sex
			}
		});

		this.bindDrill();

		this._drillDownPanel.setWidth(this.getWidth());
		this._drillDownPanel.setHeight(this.getHeight());

		this._drillDownPanel.refresh();

		this._drillDownPanel.getTopAppBar().setCaption(state.Name);

		this._DrillDownMode = true;
	}

	bindDrill()
	{
		this._drillDownPanel.getTopAppBar().EvBackClick.add(() =>
		{
			this._DrillDownMode = false;
			NP.showNode(this._statesListNode);
			this._drillDownPanel.destroy();
			this._drillDownPanel = null;
		}, this)

		this._drillDownPanel.getTopAppBar().getMainButton().setIsVisible(false);
		this._drillDownPanel.getTopAppBar().setShowBackButton(true)
	}


	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	refresh()
	{
		this._refreshList();

		this._onScrolled(null, {
			scroll: 0,
			isSmall: this._dataTable.getIsSmall()
		});
	}

	_refreshList(args?: IStateFiltersSort)
	{
		this._dataTable.setRows([]);

		if (!args)
			args = {} as IStateFiltersSort;

		args.SportType = getSportType(this._PageMode)

		ServerAPI.post("/battle/getStatesWithRank", {FilterText: this._FilterText, ...args}).then((states: IState[]) =>
		{
			if (states)
			{
				this._States = states.map(el => ({
					State: el,
					Name: el.Name,
					ISO: el.ISO,
					Id: el.Id,
					Rating: Math.round(el.Raiting * 100) / 100,
					SumRating: Math.round(el.SumRaiting * 100) / 100,
					Efficiency: Math.round(el.Efficiency * 100) / 100,
					Image: this.getStateImage(el)
				}));

				// this._dataTable.getRightPagButton().setEnabled(this._States.length == this._Count);
				// this._dataTable.updatePagCaption(`${this._Offset} - ${Math.min(this._Offset + this._Count, this._States.length)} ${NP.RM.getString("of")} ${this._States.length}`);
				// this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);
				// this._dataTable.setShowPaginator(this._States.length > this._Count);

				this._dataTable.setRows(this._States);

				if (args)
					switch (args.SortField)
					{
						case 'SumRaiting':
							this._dataTable.updateSortIndicator(1, args.SortDirection);
							break;
						case 'Efficiency':
							this._dataTable.updateSortIndicator(2, args.SortDirection);
							break;
						case 'Rating':
							this._dataTable.updateSortIndicator(3, args.SortDirection);
							break;
					}
			}
		});
	}

	getStateImage(state: IState)
	{
		if (state.ISO)
		{
			return `<img class="state-icon" src="${'/static/img/flags/' + state.ISO + '.png'}"/>`
		}
		else
		{
			let letter = state.Name;
			return `<div class="state-icon list-default-avatar"  style="background-color:${getCharColor(letter)}"></div>`;
		}
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
		this._filtersPanel.setHeight(h);

		if (this._drillDownPanel)
			this._drillDownPanel.setHeight(this.getHeight());

		this.updateMapSize();
	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight() - this._tabs.getOffsetHeight();
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);


		if (this._drillDownPanel)
			this._drillDownPanel.setWidth(this.getWidth());

		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}

		this.updateMapSize();
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	getDataTable()
	{
		return this._dataTable;
	}

	isDrillDownMode()
	{
		return this._DrillDownMode;
	}

	getDrillDownPanel()
	{
		return this._drillDownPanel;
	}

	renderMap()
	{
		NP.showNode(this._mapNode)

		if (!(<any>window).Highcharts)
			return loadFile('highcharts.js').then(() => this.isLive() && this.renderMap());

		let topo = {name: 'countries/ru/custom/ru', url: window.location.origin + "/static/img/topobase/ru.js"};

		if (!loadedMaps[topo.url])
		{

			loadFile(topo.url).then(() =>
			{
				loadedMaps[topo.url] = true;
				this.renderMap();
			});
			return;
		}


		let hc = (<any>window).Highcharts


		let data = this._States.map(s => ({
			code: s.ISO.toUpperCase().split("-")[1],
			value: s.Rating,
			name: s.Name
		}))


		this.mapChart = hc.mapChart(this._mapNode, {
			credits: {enabled: false},
			plotOptions: {
				series: {
					point: {
						events: {
							click: (ev: any) =>
							{
								let state = this._States.find(s => s.ISO.toUpperCase().split("-")[1] == ev.point.code)
								if (state)
								{
									if (this._PageMode == PageMode.mmastates)
										this.showRegionCard(state.State)
									else
										this.showAthletesFilteredByState(state.State);
								}
							}
						}
					}
				}
			},
			chart: {
				map: topo.name,
				borderWidth: 0,
				width: this._Width,
				height: this._Height - 64 - 44
			},
			exporting: {
				enabled: false
			},
			title: {
				text: NP.RM.getString('Rating')
			},
			legend: {
				layout: 'horizontal',
				borderWidth: 0,
				backgroundColor: 'rgba(255,255,255,0.85)',
				verticalAlign: 'bottom',
			},

			mapNavigation: {
				enabled: true
			},

			colorAxis: {
				type: 'uniform'
			},

			series: [{
				animation: {
					duration: 1000
				},
				data: data,
				joinBy: ['postal-code', 'code'],
				dataLabels: {
					enabled: false
				},
				name: NP.RM.getString('Rating'),
				tooltip: {
					pointFormat: '{point.options.name}: {point.value}'
				}
			}]
		});

	}

	updateMapSize()
	{
		if (this._sizeTimeout)
			clearTimeout(this._sizeTimeout);
		this._sizeTimeout = setTimeout(() => this.updateSizeTimeout(), 20);
	}

	protected updateSizeTimeout()
	{
		this._sizeTimeout = null;
		if (this.mapChart)
			this.mapChart.setSize(this._Width, this._Height - 64 - 44);
	}
}